import logo from './logo.svg';
import './App.css';
import Header from './components/header/Header';
import Hero from './components/hero/Hero';
import About from './components/about/About';
import Ministries from './components/ministries/Ministries';
import Events from './components/events/Events';
import Sermons from './components/sermons/Sermons';
import Donate from './components/donate/Donate';
import Contact from './components/contact/Contact';
import Footer from './components/footer/Footer';

function App() {
  return (
    <div>
    <Header />
    <Hero />
    <About />
    <Ministries />
    <Events />
    <Sermons/>
    <Donate/>
    <Contact/>
    <Footer/>
    </div>
  );
}

export default App;
